import { Button } from 'components/buttons/Button/Button';
import Label from 'components/Label';
import TextWithIcon from 'components/TextWithIcon';
import { ROUTES } from 'constants/routes';

const HeroNewsCard = ({ card, array }) => {
    const { slug, title, title_background, type, time_to_read, crated_at } = card;

    const moveSlideHeroNews = el => {
        const activeSlide = document.querySelector('.slider-head .swiper-slide-active');

        if (activeSlide) {
            activeSlide.classList.remove('swiper-slide-active');

            const targetSlide = document.querySelector(`.slider-head [data-swiper-slide-index="${el}"]`);

            if (targetSlide) {
                targetSlide.classList.add('swiper-slide-active');

                const swiper = document.querySelector('.slider-head').swiper;

                if (swiper) {
                    swiper.slideTo(el);
                }
            }
        }
    };

    return (
        <>
            <img className="news-wrapper-image" src={title_background} alt="plants" />
            <div className="news-box">
                <div>
                    <Label>{type}</Label>
                    <p className="description-demibold">{title}</p>
                    <div className="news-time-data">
                        <TextWithIcon iconName="calendar" text={crated_at} />
                        <TextWithIcon iconName="clock" text={time_to_read} />
                    </div>
                </div>
                <div className="news-box-bottom">
                    <Button href={ROUTES.posts + '/' + slug} type="learn-more-arrow white-text">
                        {/* TODO add real text */}
                        LEARN MORE
                    </Button>
                    <div className="pagination-wrapper">
                        {array?.map((el, index) => (
                            <div
                                onClick={() => moveSlideHeroNews(index)}
                                key={el.slug}
                                className={`pagination-dot ${card.slug === el.slug && 'active-dot'}`}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeroNewsCard;
